import { ReactNode } from "react"

type BaseButtonProps = {
    label: string
    func: (e?: any) => void
    classProps?: string
    disabled?: boolean
    type?: "button" | "submit" | "reset"
    icon: ReactNode
    hideLabelOnMobile?: "sm" | "md" | "lg" | "xl" | "2xl" | "always"
}

export default function BaseButton(props: BaseButtonProps) {
    return (
        <button
            type={props.type}
            disabled={props.disabled}
            className={`btn bg-white shadow-lg border-none hover:bg-gray-100 ${props.classProps}`}
            onClick={props.func}>
            {props.icon}
            <p className={props.hideLabelOnMobile === "always" ? "hidden" : props.hideLabelOnMobile && `hidden ${props.hideLabelOnMobile}:block ${props.label === "" ? "!hidden" : ""}`}>{props.label}</p>
        </button>
    )
}
